import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Calendar, Home } from "lucide-react";
import Layout from "../components/Layout";
import { GhostButton } from "../components/PrimaryButton";
import { getBooking } from "../lib/bookingState";
import { formatDateTime } from "../lib/format";

export default function Sucesso() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const type = params.get("type") || "novo";
  const isRemarcacao = type === "remarcacao";
  const booking = getBooking();
  const dataHora = booking.confirmacao?.data_hora || booking.data_hora;

  return (
    <Layout>
      <div className="fade-up text-center pt-6">
        <div className="w-20 h-20 mx-auto rounded-full bg-[#D6E1EE] flex items-center justify-center text-[#00357C]">
          <CheckCircle2 size={40} strokeWidth={2} />
        </div>
        <h1 className="text-3xl tracking-tight font-bold text-slate-900 mt-5" style={{ fontFamily: "Manrope" }} data-testid="sucesso-title">
          {isRemarcacao ? "Consulta remarcada!" : "Consulta agendada!"}
        </h1>
        <p className="text-slate-600 mt-2">
          {isRemarcacao
            ? "Seu novo horário foi confirmado com sucesso."
            : "Estamos felizes em receber você. Até breve!"}
        </p>
      </div>

      {dataHora && (
        <div className="mt-8 bg-white border border-slate-200 rounded-2xl p-5">
          <div className="flex items-start gap-3">
            <div className="w-11 h-11 rounded-xl bg-[#E6EDF5] text-[#00357C] flex items-center justify-center shrink-0">
              <Calendar size={20} />
            </div>
            <div className="min-w-0">
              <div className="text-xs uppercase tracking-[0.16em] font-semibold text-slate-500">
                Data e horario
              </div>
              <div className="text-slate-900 font-medium mt-1">{formatDateTime(dataHora)}</div>
            </div>
          </div>
        </div>
      )}

      <div className="mt-8 bg-[#EAF5F6] border border-[#D7EBED] rounded-2xl p-4 text-sm text-[#1F4D52]">
        Em caso de dúvida, você sempre pode entrar em contato pelo WhatsApp da clínica. Lembre-se de chegar com 15 minutos de antecedência.
      </div>

      <div className="mt-8">
        <Link to="/">
          <GhostButton data-testid="sucesso-home">
            <Home size={18} /> Ir para o inicio
          </GhostButton>
        </Link>
      </div>
    </Layout>
  );
}
